import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const SendThankYouEmailForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.beo_to_email_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'to',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: true,
      multiline: true,
      minRows: 1,
      maxRows: 3,
    },
    {
      label: strings.beo_cc_email_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'cc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 7,
    },
    {
      label: strings.beo_bcc_email_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'bcc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 7,
    },
  ];
};
